export const EMAIL_MESSAGES = [];

export const SALESFORCE_NOT_CONFIGURED_MESSAGE = 'Salesforce is not configured.';
